import { Link } from 'react-router-dom'

/**
 * The Edvantage logo, 22px high, at the start of the top bar and nowhere else (Yousef's guideline). Never inverted,
 * tinted, mirrored or tiled, and no subtitle. It does not touch `components/shell/Brand.tsx`, which the exam room uses.
 * The alt text is the brand name, which stays Latin in Arabic.
 */
export function R5Logo({ to = '/home' }: { to?: string }) {
  return (
    <Link to={to} className="r5-logo">
      <img src="/assets/Edvantage-Logo.svg" alt="Edvantage" height={22} />
    </Link>
  )
}
